import { __awaiter } from "tslib";
import * as _ from "lodash";
import * as React from "react";
import { OverlayTrigger, Popover, Row } from "react-bootstrap";
import * as semver from "semver";
import { Utilities } from "../../shared/utilities";
import { setLastReadVersion } from "../actions/AppActions";
import { AppContext, releaseNoteStorageKey } from "../App";
import NotificationMessageNotifier from "./NotificationMessageNotifier";
const NotificationCenter = () => {
    var _a, _b;
    const target = React.useRef(null);
    const { appState, dispatch } = React.useContext(AppContext);
    const [isShowingPopover, setIsShowingPopover] = React.useState(false);
    const [releaseNote, setReleaseNote] = React.useState();
    React.useEffect(() => {
        const fetchCoreVersion = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const coreVersion = yield Utilities.getFetch("api/navigation/getUIVersion");
                const splitVersion = coreVersion.split(".").slice(0, -1);
                const semanticJoin = splitVersion.join(".");
                const urlJoin = splitVersion.join("");
                setReleaseNote({
                    version: semanticJoin,
                    intercomLink: `https://docs.frends.com/en/articles/4953793-5-4-release-notes#${urlJoin}`
                });
            }
            catch (e) {
                console.error(e);
                Utilities.toastError(e);
            }
        });
        fetchCoreVersion();
    }, []);
    const [isTriggeringAnimation, setIsTriggeringAnimation] = React.useState(false);
    const shouldTriggerAnimation = () => {
        var _a, _b, _c, _d, _e;
        if (!_.isEmpty((_a = appState) === null || _a === void 0 ? void 0 : _a.notificationMessages) && ((_b = appState) === null || _b === void 0 ? void 0 : _b.notificationMessages.some((s) => s.viewed !== true)) ||
            ((_c = appState) === null || _c === void 0 ? void 0 : _c.lastReadVersion) !== "" && !_.isEqual((_d = appState) === null || _d === void 0 ? void 0 : _d.lastReadVersion, (_e = releaseNote) === null || _e === void 0 ? void 0 : _e.version)) {
            return true;
        }
        else {
            return false;
        }
    };
    React.useEffect(() => {
        setIsTriggeringAnimation(shouldTriggerAnimation());
    }, [appState]);
    React.useEffect(() => {
        var _a;
        if (isShowingPopover) {
            setLastReadVersion(dispatch, (_a = releaseNote) === null || _a === void 0 ? void 0 : _a.version, releaseNoteStorageKey);
            setIsTriggeringAnimation(shouldTriggerAnimation());
        }
    }, [isShowingPopover]);
    const toggleIsShowingPopover = () => {
        setIsShowingPopover(!isShowingPopover);
    };
    const popOver = (React.createElement(Popover, { id: "navigation-notification-popover", style: { padding: 0 } },
        React.createElement(NotificationMessageNotifier, { state: { appState, dispatch } }),
        React.createElement("div", { style: { overflowY: "auto" } },
            React.createElement(Row, null,
                React.createElement("h4", { style: { marginTop: 0 } },
                    React.createElement("strong", null, "Release notes")),
                React.createElement("a", { href: (_a = releaseNote) === null || _a === void 0 ? void 0 : _a.intercomLink, target: "_blank", className: "italic-blue-link" },
                    React.createElement("p", null,
                        "Release notes for ",
                        semver.valid(semver.coerce((_b = releaseNote) === null || _b === void 0 ? void 0 : _b.version)))),
                React.createElement("a", { target: "_blank", className: "italic-blue-link", href: "https://docs.frends.com/en/collections/1192384-release-notes" }, "All release notes")))));
    return (React.createElement("li", { role: "presentation", id: "navigation-notification", ref: target, onClick: toggleIsShowingPopover },
        React.createElement(OverlayTrigger, { trigger: "click", placement: "bottom", overlay: popOver, containerPadding: 20, rootClose: true },
            React.createElement("p", { className: "navbar-text" },
                React.createElement("i", { className: "fa fa-bell pointer", id: `navigation-changelog-bell${isTriggeringAnimation ? "-animating" : ""}` }))),
        isTriggeringAnimation && React.createElement("div", { id: "navigation-changelog-badge" })));
};
export default NotificationCenter;
